import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-dummy-roof]',
    templateUrl: './dummy-roof.component.html',
    styleUrl: './dummy-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DummyRoofComponent {
  type = input<BuildingType>();
}
